import "./../styles.scss";

import { notification, Select } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import CloseModal from "../../../components/icons/CloseModal";
import { editZeeFolderValidation } from "../../../utils/validations";

const EditSubClient = ({ ...props }) => {
  const { Option } = Select;
  const {
    editmodalOpen,
    setEditModalOpen,
    tenantDetails,
    getTenants,
    tenantNames,
    clientUser,
    updateTenant,
    getUser,
    userDetails,
  } = props;

  const [disable, setDisable] = useState(false);
  const [userArray, setUserArray] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [initialValues, setInitialValues] = useState({
    name: tenantDetails?.name,
    associateUsers: tenantDetails?._id,
  });
  const closeModal = () => {
    setEditModalOpen(false);
    const users = [];
    const userIds = [];
    tenantDetails?.users?.length !== 0 &&
      tenantDetails?.users?.map((alluser) => {
        userIds.push(alluser.userId);
        users.push({
          value: alluser.userId,
          label: `${alluser.name}-${alluser.email}`,
        });
      });
    setSelectedUser(userIds);
  };

  useEffect(() => {
    const users = [];
    const userIds = [];
    tenantDetails?.users?.length !== 0 &&
      tenantDetails?.users?.map((alluser) => {
        userIds.push(alluser.userId);
        users.push({
          value: alluser.userId,
          label: `${alluser.name}-${alluser.email}`,
        });
      });
    setSelectedUser(userIds);

    setInitialValues({
      ...initialValues,
      name: tenantDetails.name,
      _id: tenantDetails?._id,
      associateUsers: users,
    });
  }, [tenantDetails]);

  //Edit existing folder
  const handleSubmit = async () => {
    if (tenantNames.filter((e) => e._id !== initialValues?._id && e.name === initialValues?.name).length > 0) {
      notification["error"]({ message: "Client Name Already Exists" });
    } else {
      setDisable(false);
      const payload = {
        id: tenantDetails?._id,
        associateUsers: selectedUser,
        name: tenantDetails?.name,
        createdBy: localStorage.getItem("__uid"),
      };
      const data = await updateTenant(payload);
      if (data.value.success || data.value.status) {
        notification["success"]({ message: data.value.message });
      } else {
        notification["error"]({ message: data.value.message });
      }
      getTenants();
      getUser();
      closeModal();
    }
  };

  const editTenantName = (e, setFieldValue) => {
    setFieldValue("name", e);
    setInitialValues({ ...initialValues, name: e });
  };
  const setClientUserName = (value, setFieldValue) => {
    setFieldValue("users", value);
    setSelectedUser(value);
  };
  // useEffect(() => {
  //   const users = [];
  //   tenantDetails?.users?.length !== 0 &&
  //     tenantDetails?.users?.map((alluser) => {
  //       users.push({
  //         value: alluser.userId,
  //         label: `${alluser.name}-${alluser.email}`,
  //       });
  //     });
  //   setSelectedUser(users);
  // }, [tenantDetails]);

  return (
    <>
      <Modal
        isOpen={editmodalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Sub Client Name</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={editZeeFolderValidation}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Sub Client Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="name"
                        disabled={true}
                        value={initialValues?.name}
                        onChange={(e) => editTenantName(e.target.value, setFieldValue)}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">
                        {" "}
                        Select users <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          showSearch
                          className="custom-ant-select"
                          name="users"
                          onChange={(value, option) => setClientUserName(value, setFieldValue)}
                          //onChange={(value) => setFieldValue("users", value)}
                          component={Select}
                          mode="multiple"
                          dropdownStyle={{ zIndex: 99999999 }}
                          placeholder="Select Users"
                          value={selectedUser}
                        >
                          {userDetails?.length &&
                            userDetails?.map((data, index) => {
                              return (
                                <>
                                  <Option key={index} value={data.userId} data={data}>
                                    {data.name}-{data.email}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                      </div>
                    </div>
                    <button className="btn btn-primary" type="submit">
                      Edit
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditSubClient;
